export const EXISTING_LITTER_SUBSCRIPTION_ALERT_ID = "existingLitterSubscriptionAlert" as const;
